import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "integrations-yellow",
  "use": "integrations-yellow-usage",
  "viewBox": "0 0 253 151",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 253 151\" id=\"integrations-yellow\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M207.883 5.856c15.502-2.237 30.68-4.428 44.88-5.036V151H0c.187-5.565.628-11.122 1.322-16.638C6.695 91.111 27.81 50.467 60.005 31.292c24.482-14.582 55.372-16.75 88.057-19.046 10.298-.723 20.774-1.458 31.285-2.598 9.533-1.05 19.095-2.43 28.536-3.792z\" fill=\"#FFDC82\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol